import { render, staticRenderFns } from "./PagePerformanceReviewTemplateEdit.vue?vue&type=template&id=090e047d&"
import script from "./PagePerformanceReviewTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports